export const SAFE_MARGIN_MM = 1.7;
